/**
 * Mapeamento dinâmico de ícones para profiles
 * Permite que ícones sejam configurados via banco de dados
 */
import { LuBadgeDollarSign } from "react-icons/lu";
import { FaRegUser, FaFileInvoiceDollar } from "react-icons/fa";
import { TbLetterA, TbLetterV, TbSignature } from "react-icons/tb";
import { ImManWoman } from "react-icons/im";
import { FaUserTie } from "react-icons/fa6";
import { ComponentType } from "react";

export const ICON_MAP: Record<string, ComponentType<any>> = {
  // Pessoa Jurídica
  'FaRegUser': FaRegUser,                           // ISSUER - Emitente
  'LuBadgeDollarSign': LuBadgeDollarSign,          // RECIPIENT - Beneficiário
  'TbLetterV': TbLetterV,                          // GUARANTOR-RETAIL - Avalista varejo
  'TbLetterA': TbLetterA,                          // GUARANTOR-WHOLESALE - Avalista atacado
  'FaFileInvoiceDollar': FaFileInvoiceDollar,      // DRAWEE - Sacado
  
  // Pessoa Física
  'TbSignature': TbSignature,                      // SIGNATORY - Signatário
  'ImManWoman': ImManWoman,                        // CONSENTING_PARTY - Anuente
  'FaUserTie': FaUserTie,                          // FINANCIAL_REPRESENTATIVE - Rep. financeiro
};

/**
 * Obtém componente de ícone baseado no nome
 * @param iconName Nome do ícone (ex: 'FaRegUser')
 * @returns Componente React do ícone ou ícone padrão
 */
export const getIconComponent = (iconName: string): ComponentType<any> => {
  return ICON_MAP[iconName] || FaRegUser; // Fallback para ícone padrão
};
